import "./DialPad.css"
import Div from "../base/Div";
import FlexRow from "../base/FlexRow";
import Icon from "../base/Icon";
import { useEffect, useRef, useState } from "react";


interface IProps {
    onDial: (number: string) => {

    }
}
export default function DialPad(props: IProps) {

    const inputRef = useRef<HTMLInputElement>(null)
    const [value, setValue] = useState("")
    const [fontSize, setFontSize] = useState(38)

    const formatPhone = (chars: string) => {

        const first3 = chars.slice(0, 3);
        const second3 = chars.slice(3, 6);
        const rest = chars.slice(6);

        let formatted = "";

        if (first3) formatted = `(${first3}`;
        if (chars.length >= 3) formatted += ")";
        if (second3) formatted += ` ${second3}`;
        if (rest) formatted += ` ${rest}`;

        return formatted;
    }

    useEffect(() => {
        var size = 38;
        if (value.length > 10) {
            size = 38 - (value.length - 10);
        }
        setFontSize(size);
    }, [value])

    useEffect(() => {
        inputRef.current?.focus()
    }, [value])


    return (
        <FlexRow className="mx-10 mb-10" column>
            <input type="text" className="dialpad-text"
                ref={inputRef} autoFocus
                onChange={e => {
                    const raw = e.target.value.replace(/[^0-9,+]/g, "")
                    setValue(raw)
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        props.onDial(value)
                    }
                }}
                value={value}
                style={{
                    fontSize: fontSize
                }} />

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "1")}>
                    1
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "2")}>
                    2
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "3")}>
                    3
                </Div>
            </FlexRow>

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "4")}>
                    4
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "5")}>
                    5
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "6")}>
                    6
                </Div>
            </FlexRow>

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "7")}>
                    7
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "8")}>
                    8
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "9")}>
                    9
                </Div>
            </FlexRow>

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "+")}>
                    +
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + "0")}>
                    0
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value + ",")}>
                    ,
                </Div>
            </FlexRow>

            <FlexRow className="w-100" justify="center">
                <Div className="dialpad-number">

                </Div>
                <Div className="dialpad-number">
                    <a href="#" onClick={e => {
                        e.preventDefault()
                        props.onDial(value)
                    }}>
                        <Icon icon="phone-circle" type="solid" className="text-success" size={60} />
                    </a>
                </Div>
                <Div className="dialpad-number"
                    onClick={e => setValue(value.substring(0, value.length - 1))}>
                    <Icon icon="delete-left" type="solid" className="text-gray-600" size={36} />
                </Div>
            </FlexRow>

        </FlexRow>
    )
}